import { RouteRecordRaw } from 'vue-router';
import { benchmarksRoutes } from './benchmarksRoutes.ts';
import { marketsRoutes } from './marketsRoutes.ts';
import { forecastsRoutes } from './forecastsRoutes.ts';
import { assetsRoutes } from './assetsRoutes.ts';

export const enactRoutes: Record<string, RouteRecordRaw> = {
    benchmarks: {
        path: 'benchmarks',
        name: 'benchmarks',
        redirect: { name: benchmarksRoutes.redirect.name },
        component: () => import('@/views/powerMarkets/BenchmarkHolderView.vue'),
        children: [...Object.values(benchmarksRoutes)],
        meta: {
            headName: 'Benchmarks',
            isEnact: true,
            isOldEnact: true,
            hasTabbedSubNav: true,
            blockTopLevelNoAccess: true,
            searchMeta: {
                noSearch: true,
            },
        },
    },
    markets: {
        path: 'markets',
        name: 'markets',
        redirect: { name: marketsRoutes.redirect.name },
        children: [...Object.values(marketsRoutes)],
        meta: {
            headName: 'Live Markets',
            isEnact: true,
            isOldEnact: true,
            sidebar: true,
            searchMeta: {
                noSearch: true,
            },
        },
    },
    assets: {
        path: 'assets',
        name: 'assets',
        redirect: { name: assetsRoutes.redirect.name },
        children: [...Object.values(assetsRoutes)],
        meta: {
            headName: 'Asset Pipeline',
            isEnact: true,
            sidebar: true,
            searchMeta: {
                noSearch: true,
            },
        },
    },
    forecasts: {
        path: 'forecasts',
        name: 'forecasts',
        redirect: { name: forecastsRoutes.redirect.name },
        component: () => import('@/views/storageForecasting/ForecastingHolderView.vue'),
        children: [...Object.values(forecastsRoutes)],
        meta: {
            headName: 'Long-Term Forecasts',
            blockTopLevelNoAccess: true,
            isEnact: true,
            hasTabbedSubNav: true,
            searchMeta: {
                noSearch: true,
            },
        },
    },
};
